module.exports = __webpack_public_path__ + "static/media/Icon-2.db91e33e.svg";